import React, { useState } from 'react';
import Loader from 'react-loader-spinner';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import './VotePageView.css';
import { Logo } from "../_components/Logo";
import NotesEditorModal from './NotesEditorModal/NotesEditorModal';
import RatingInputStar from './RatingInputStar/RatingInputStar';


export const VotePageView = props => {

    const [showNotesModal, setShowNotesModal] = useState(false);
    const [currentEditingNotes, setCurrentEditingNotes] = useState('');
    const [currentEditingTeamId, setCurrentEditingTeamId] = useState(null);

    const handleShowNotesModal = (teamId, initialNotes) => {
        setCurrentEditingTeamId(teamId);
        setCurrentEditingNotes(initialNotes);
        setShowNotesModal(true);
    };

    const handleCloseNotesModal = () => {
        setShowNotesModal(false);
        setCurrentEditingNotes('');
        setCurrentEditingTeamId(null);
    };

    const handleSaveNotes = (notesToSave) => {
        if (props.onNoteChange) {
            props.onNoteChange(currentEditingTeamId, notesToSave);
        }
        handleCloseNotesModal();
    };

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        if (result.source.index === result.destination.index) {
            return;
        }

        props.onReorderTeams(result.source.index, result.destination.index);
    };

    const categoryHeaders = props.categories.map(c => (
        <div key={c.id} className="column category-header header-category-item">{c.name}</div>
    ));

    const teamsList = props.teams;

    console.log('props', props.isFrozen);

    if (props.loading) return (
        <div className="spinner-container">
            <Loader type="TailSpin"
                color="#CF240A"
                height="60" width="60" />
        </div>
    );

    return (
        <div className="section-container">
            <div className="grid-wrap">
                <div className="grid-main-header-top-row">
                    <div className="judge-name-display" style={{ textTransform: 'capitalize' }}>{props.judgeName.split('@')[0]}</div>
                    {!props.isMobile && (
                        <div className="header-categories">
                            {categoryHeaders}
                        </div>
                    )}

                    <button
                        className='btn btn-primary save-scores-button'
                        onClick={props.onSave}
                        style={{ visibility: props.ownPage ? 'visible' : 'hidden' }}
                    >
                        Save Scores
                    </button>
                </div>
            {
                props.isFrozen &&(
                    <div className="freeze-message">
                        <i className="fas fa-lock"></i>
                        Scores have been frozen. Voting is no longer available.
                    </div>
                )
            }
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="teams-list">
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className="teams-droppable-container"
                            >
                                {teamsList.map((t, index) => (
                                    <Draggable key={t.id} draggableId={String(t.id)} index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                className="columns draggable-team-row"
                                                style={{
                                                    ...provided.draggableProps.style,
                                                    backgroundColor: snapshot.isDragging ? '#f0f0f0' : 'white',
                                                }}
                                            >
                                                {!props.isMobile && <div
                                                    className="column drag-handle-column"
                                                    {...provided.dragHandleProps}
                                                >
                                                    {props.ownPage && (
                                                        <svg className="drag-handle-icon" viewBox="0 0 24 24" fill="#D2D2D3">
                                                            <circle cx="6" cy="6" r="2" />
                                                            <circle cx="14" cy="6" r="2" />

                                                            <circle cx="6" cy="14" r="2" />
                                                            <circle cx="14" cy="14" r="2" />

                                                            <circle cx="6" cy="22" r="2" />
                                                            <circle cx="14" cy="22" r="2" />
                                                        </svg>
                                                    )}
                                                </div>}

                                                <div className="column column-1-7 team-name">
                                                    <div className="image">
                                                        <Logo source={t.logo}></Logo>
                                                    </div>
                                                </div>

                                                <div
                                                    className={`column column-1-7 scores`}
                                                    style={props.isMobile ? { display: 'block' } : {}}
                                                >
                                                    {
                                                        t.scores.map(s => (
                                                            <React.Fragment key={s.categoryId}>
                                                                {props.isMobile ? <div key={s.id} className="column column-1-7 category">{s.categoryName}</div> : null}
                                                                <div className={props.isFrozen ? "frozen-score":""}>
                                                                <RatingInputStar
                                                                    value={s.score ?? ''}
                                                                    edit={props.ownPage}
                                                                    onChange={(newRating) => {
                                                                        if(props.isFrozen) return;
                                                                        props.onRateChange(
                                                                        t.id,
                                                                        s.categoryId,
                                                                        newRating === '' || newRating == null ? null : Number(newRating)
                                                                        );
                                                                    }
                                                                    }
                                                                    maxRating={5.0}
                                                                    step={0.5}
                                                                />
                                                                </div>
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </div>
                                                <div className="column column-1-7 notes-button-column" >
                                                    <button
                                                        className="btn btn-primary"
                                                        disabled={props.isFrozen}
                                                        onClick={() => handleShowNotesModal(t.id, t.notes)}
                                                    >
                                                        {props.ownPage ? 'Enter Notes' : 'View Notes'}
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>

            <NotesEditorModal
                show={showNotesModal}
                handleClose={handleCloseNotesModal}
                initialNotes={currentEditingNotes}
                onSave={handleSaveNotes}
                ownPage={props.ownPage}
            />
        </div>
    );
};

export default VotePageView;